import { HeadlessButton, Popover } from "@kensho/neo";
import { use, useMemo } from "react";

import { SpellCheckContext } from "../../../providers/spell-check-context";
import { APITranscriptToken, TranscriptSelection } from "../../../types/types";
import { DICTIONARIES } from "../../account/dictionaries";
import { ReviewSpelling } from "./review/review-spelling";

interface Props {
  sliceIndex: number;
  tokenIndex: number;
  token: APITranscriptToken;
  onClose: () => void;
}

export function TokenPopover(props: Props) {
  const { sliceIndex, tokenIndex, token, onClose } = props;
  const spellCheck = use(SpellCheckContext);
  const dictionaryResource = DICTIONARIES.find(
    (d) => d.langCode === spellCheck.langCode,
  );

  const transcriptSelection = useMemo<TranscriptSelection>(
    () => ({
      type: "Range",
      start: {
        type: "token",
        sliceIndex,
        tokenIndex,
        textOffset: 0,
      },
      end: {
        type: "token",
        sliceIndex,
        tokenIndex,
        textOffset: token.transcript.length,
      },
    }),
    [sliceIndex, tokenIndex, token],
  );

  return (
    <div className="pointer-events-none absolute top-0 right-0 bottom-0 left-0">
      <Popover
        isOpen
        onOpenChange={onClose}
        position="bottom-start"
        content={
          <div className="flex h-[260px] w-[380px] flex-col">
            <header className="flex h-12 items-center justify-between border-b border-gray-200 p-4">
              <h2>Spelling ({dictionaryResource?.label} dictionary)</h2>
            </header>
            <ReviewSpelling
              transcriptSelection={transcriptSelection}
              onComplete={() => onClose()}
            />
          </div>
        }
      >
        <HeadlessButton />
      </Popover>
    </div>
  );
}
